const THUMBNAIL_WIDTH = 380;
const THUMBNAIL_HEIGHT = 200;

export function getThumbnailUrl(thumbnail) {
    if (!thumbnail) return '';
    const separator = thumbnail.includes('?') ? '&' : '?';
    return `${thumbnail}${separator}width=${THUMBNAIL_WIDTH}&height=${THUMBNAIL_HEIGHT}`;
}
